import { faCirclePlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Intermediat_Check_Form.css";
import Select from "react-select";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  CreateIntermediateEquipment,
  GetAllIntermediate,
} from "../../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import { AllPermissionDropdown } from "../../../../../../../../features/admin/common/Slice";
import { FixIDS } from "../../../../../../../../utils/fixIDS";

function Intermediat_Check_Form({ onProceed, all_instruments, setSearchName }) {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      user_id: null,
      instrument_id: null,
      date: "",
      std_value_in_grams: "",
      weight_in_grams: "",
      remark: "",
      observations: [
        {
          value: "",
        },
      ], // ✅ always 1 row
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "observations",
  });

  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("user_id", data?.user_id?.value);
      sendData.append("instrument_id", data?.instrument_id?.value);
      sendData.append("calibrated_by_id", data?.calibrated_by_id?.value);
      sendData.append("accureacy_status", data?.accuracy_status ? true : false);
      sendData.append("date", data?.date);
      sendData.append("std_value_in_grams", data?.std_value_in_grams);
      sendData.append("weight_in_grams", data?.weight_in_grams);
      sendData.append("remark", data?.remark);
      const observations = [];
      data.observations.forEach((val, index) => {
        observations.push({
          value: val.value,
          // weight_ingram: val.weight_ingram,
          // std_value: val.std_value,
        });
      });

      sendData.append("observations", JSON.stringify(observations));

      const res = await dispatch(
        CreateIntermediateEquipment({ data: sendData }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        reset({
          user_id: null,
          instrument_id: null,
          date: "",
          std_value_in_grams: "",
          weight_in_grams: "",
          remark: "",
          observations: [],
        });
        setSuccess(true);
        dispatch(GetAllIntermediate({}));
        setTimeout(() => {
          setSuccess(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  const allPermissionDropdown = useSelector(
    (state) => state.common.all_permission_dropdown,
  );
  useEffect(() => {
    dispatch(
      AllPermissionDropdown({ permission_id: FixIDS.intermediate_check.List }),
    );
  }, [dispatch]);

  console.log(errors, "errors errors");

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="white_container customer_section">
              <div className="row">
                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Instrument</Form.Label>
                    <Controller
                      className="select-contoller"
                      name="instrument_id" // name of the field
                      control={control}
                      rules={{
                        required: "Select Instrument",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.instrument_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          options={all_instruments}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            setValue(
                              "instrument_unique_id",
                              selectedValue?.data?.unique_id || "",
                            );

                            // set calibrate instrument
                            // setValue(
                            //   "calibrate_instrument",
                            //   selectedValue?.data?.User?.name || "",
                            // );
                          }}
                        />
                      )}
                    />

                    {errors.instrument_id && (
                      <Form.Text className="text-danger">
                        {errors.instrument_id.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                {/* ---------------- Instrument ID ---------------- */}
                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Instrument ID</Form.Label>

                    <Form.Control
                      readOnly
                      placeholder="Instrument ID"
                      {...register("instrument_unique_id", {
                        // required: "Instrument ID is required",
                      })}
                    />

                    {errors.instrument_unique_id && (
                      <Form.Text className="text-danger">
                        {errors.instrument_unique_id.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                {/* ---------------- Calibrate Instrument ---------------- */}
                {/* <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Calibrate Instrument By</Form.Label>

                    <Form.Control
                      readOnly
                      placeholder="Calibrate Instrument"
                      {...register("calibrate_instrument", {
                        // required: "Calibration value is required",
                      })}
                    />

                    {errors.calibrate_instrument && (
                      <Form.Text className="text-danger">
                        {errors.calibrate_instrument.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div> */}

                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Calibrate Instrument By</Form.Label>
                    <Controller
                      className="select-contoller"
                      name="user_id" // name of the field
                      control={control}
                      rules={{
                        required: "Select Calibrate Instrument By",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.user_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          options={allPermissionDropdown}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                        />
                      )}
                    />

                    {errors.user_id && (
                      <Form.Text className="text-danger">
                        {errors.user_id.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Calibrated By</Form.Label>
                    <Controller
                      className="select-contoller"
                      name="calibrated_by_id" // name of the field
                      control={control}
                      rules={{
                        required: "Select Calibrated By",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.calibrated_by_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          options={all_instruments}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                        />
                      )}
                    />

                    {errors.calibrated_by_id && (
                      <Form.Text className="text-danger">
                        {errors.calibrated_by_id.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Remark</Form.Label>

                    <Form.Control
                      placeholder="Remark"
                      {...register("remark", {
                        required: "Remark is required",
                      })}
                    />

                    {errors.remark && (
                      <Form.Text className="text-danger">
                        {errors.remark.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Weight In Grams</Form.Label>

                    <Form.Control
                      placeholder="Weight In Grams"
                      {...register("weight_in_grams", {
                        required: "Weight In Grams is required",
                      })}
                    />

                    {errors.weight_in_grams && (
                      <Form.Text className="text-danger">
                        {errors.weight_in_grams.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>STD Value (in grams)</Form.Label>

                    <Form.Control
                      placeholder="STD Value"
                      {...register("std_value_in_grams", {
                        required: "STD Value is required",
                      })}
                    />

                    {errors.std_value_in_grams && (
                      <Form.Text className="text-danger">
                        {errors.std_value_in_grams.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Date</Form.Label>
                    <Form.Control
                      type="date"
                      placeholder="Enter Date"
                      {...register("date", {
                        required: "Date is required",
                        // validate: (value) => {
                        //   const year = value.split("-")[0];

                        //   if (year.length !== 4) {
                        //     return "Year must be exactly 4 digits";
                        //   }

                        //   const selectedDate = new Date(value);
                        //   const today = new Date();
                        //   today.setHours(0, 0, 0, 0);

                        //   if (selectedDate < today) {
                        //     return "Past dates are not allowed";
                        //   }

                        //   return true;
                        // },
                      })}
                      onChange={(e) => {
                        let value = e.target.value;
                        const parts = value.split("-");

                        if (parts[0] && parts[0].length > 4) {
                          parts[0] = parts[0].slice(0, 4);
                          e.target.value = parts.join("-");
                        }
                      }}
                    />

                    {errors.date && (
                      <Form.Text className="text-danger">
                        {errors.date.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="form_group">
                    <Form.Label>Accuracy Acceptance</Form.Label>
                    <Form.Check
                      type="checkbox"
                      label="Accepted"
                      {...register("accuracy_status", {
                        required: "You must accept accuracy before submitting",
                      })}
                    />
                    {errors.accuracy_status && (
                      <Form.Text className="text-danger">
                        {errors.accuracy_status.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="heading_add_text mt-3">
                  <Form.Group className="form_group">
                    <Form.Label>Enter Observation</Form.Label>
                  </Form.Group>
                  <span onClick={() => append({ value: "" })}>
                    <FontAwesomeIcon icon={faCirclePlus} /> Add Observation
                  </span>
                </div>

                <div className="row">
                  {fields.map((field, index) => (
                    <div key={field.id} className="col-xl-2 col-lg-4  col-md-4">
                      <div className="observation_box">
                        <div className="obs_label">
                          OBS {String(index + 1).padStart(2, "0")}
                        </div>

                        <Form.Control
                          placeholder="Observations"
                          {...register(`observations.${index}.value`, {
                            required: "Observation is required",
                          })}
                          onKeyDown={(e) => {
                            const value = e.target.value;

                            // Allow control keys
                            if (
                              [
                                "Backspace",
                                "Delete",
                                "Tab",
                                "ArrowLeft",
                                "ArrowRight",
                              ].includes(e.key)
                            ) {
                              return;
                            }

                            // Allow numbers
                            if (/^[0-9]$/.test(e.key)) {
                              return;
                            }

                            // Allow ONE decimal point
                            if (e.key === "." && !value.includes(".")) {
                              return;
                            }

                            // Block everything else
                            e.preventDefault();
                          }}
                        />

                        {errors.observations?.[index]?.value && (
                          <small className="text-danger">
                            {errors.observations[index].value.message}
                          </small>
                        )}

                        {/* <Form.Control
                          placeholder="Weight in Grams"
                          {...register(`observations.${index}.weight_ingram`, {
                            required: "Weight in Grams is required",
                          })}
                          onKeyDown={(e) => {
                            const value = e.target.value;

                            // Allow control keys
                            if (
                              [
                                "Backspace",
                                "Delete",
                                "Tab",
                                "ArrowLeft",
                                "ArrowRight",
                              ].includes(e.key)
                            ) {
                              return;
                            }

                            // Allow numbers
                            if (/^[0-9]$/.test(e.key)) {
                              return;
                            }

                            // Allow ONE decimal point
                            if (e.key === "." && !value.includes(".")) {
                              return;
                            }

                            // Block everything else
                            e.preventDefault();
                          }}
                        />

                        {errors.observations?.[index]?.weight_ingram && (
                          <small className="text-danger">
                            {errors.observations[index].weight_ingram.message}
                          </small>
                        )}
                        <Form.Control
                          placeholder="STD Value"
                          {...register(`observations.${index}.std_value`, {
                            required: "STD Value is required",
                          })}
                          onKeyDown={(e) => {
                            const value = e.target.value;

                            // Allow control keys
                            if (
                              [
                                "Backspace",
                                "Delete",
                                "Tab",
                                "ArrowLeft",
                                "ArrowRight",
                              ].includes(e.key)
                            ) {
                              return;
                            }

                            // Allow numbers
                            if (/^[0-9]$/.test(e.key)) {
                              return;
                            }

                            // Allow ONE decimal point
                            if (e.key === "." && !value.includes(".")) {
                              return;
                            }

                            // Block everything else
                            e.preventDefault();
                          }}
                        />

                        {errors.observations?.[index]?.std_value && (
                          <small className="text-danger">
                            {errors.observations[index].std_value.message}
                          </small>
                        )} */}

                        {fields.length > 1 && (
                          <button type="button" onClick={() => remove(index)}>
                            ❌
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* ---------------- Buttons ---------------- */}
              <div className="permission_btn_holder">
                <Button
                  type="button"
                  className="permission_btn No_btn"
                  onClick={() =>
                    reset({
                      user_id: null,
                      instrument_id: null,
                      date: "",
                      std_value_in_grams: "",
                      weight_in_grams: "",
                      remark: "",
                      observations: [],
                    })
                  }
                  // onClick={() => window.location.reload()}
                >
                  Reset
                </Button>

                <Button type="submit" className="permission_btn Yes_btn">
                  Save
                </Button>
              </div>
            </div>
          </Form>

          {/* <div className="row">
          
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Instrument</Form.Label>
                <Select
                  options={all_instruments}
                  placeholder="Select Instrument"
                  classNamePrefix="react_select"

                />
              </Form.Group>
            </div>

         
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Instrument ID</Form.Label>
                <Form.Control placeholder="Instrument ID" />
              </Form.Group>
            </div>

          
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Calibrate Instrument</Form.Label>
                <Form.Control placeholder="Calibrate Instrument" />
              </Form.Group>
            </div>
          </div>

          <div className="permission_btn_holder">
            <Button className="permission_btn No_btn">Reset</Button>
            <Button className="permission_btn Yes_btn" onClick={onProceed}>
              Proceed
            </Button>
          </div> */}
        </div>

        {success && (
          <Success_Toster successText="Intermediate Add Successfully!" />
        )}
      </section>
    </>
  );
}

export default Intermediat_Check_Form;
